import React, { useMemo } from "react";
import { MapPin } from "lucide-react";
import { EntityCombobox } from "@/components/ui/entity-combobox";

const label = (e) => e.nombre || "—";
const secondary = (e) => [
  e.ciudad || e.provincia,
  e.direccion,
  e.codigo_pdv ? `tienda ${e.codigo_pdv}` : null,
].filter(Boolean).join(" · ");
const searchText = (e) => [
  e.nombre, e.alias, e.cadena_nombre, e.cliente_nombre, e.codigo_pdv,
  e.direccion, e.ciudad, e.provincia, e.cp,
].filter(Boolean).join(" ");

/**
 * Buscador de Espacios (misma API que la versión anterior).
 * - Búsqueda por nombre, enseña/cadena, nº tienda, dirección, localidad, CP, provincia y cliente.
 * - Si `clienteId`: los espacios de ese cliente van primero y llevan badge "Cliente".
 * - `filterByClienteId` oculta espacios de otros clientes; `excludeId` quita uno concreto.
 */
export default function EspacioCombobox({
  value,
  onChange,
  espacios = [],
  clienteId = null,
  filterByClienteId = false,
  excludeId = null,
  placeholder = "Buscar espacio…",
  disabled = false,
  testId = "espacio-combobox",
  allowNone = false,
  noneLabel = "— Sin espacio",
  emptyText = "Ningún espacio coincide",
  className = "",
}) {
  const lista = useMemo(() => {
    let arr = espacios.filter((e) => e && e.id);
    if (excludeId) arr = arr.filter((e) => e.id !== excludeId);
    if (filterByClienteId && clienteId) arr = arr.filter((e) => e.cliente_id === clienteId || !e.cliente_id);
    if (clienteId) {
      arr = [...arr].sort((a, b) => {
        const aM = a.cliente_id === clienteId ? 0 : 1;
        const bM = b.cliente_id === clienteId ? 0 : 1;
        if (aM !== bM) return aM - bM;
        return (a.nombre || "").localeCompare(b.nombre || "");
      });
    }
    return arr;
  }, [espacios, excludeId, filterByClienteId, clienteId]);

  const badge = (e) => (
    <>
      {e.cadena_nombre && (
        <span className="text-[9px] uppercase tracking-wider px-1 rounded bg-zinc-800 text-zinc-400 shrink-0">{e.cadena_nombre}</span>
      )}
      {clienteId && e.cliente_id === clienteId && (
        <span className="text-[9px] uppercase tracking-wider text-amber-400/80 shrink-0">Cliente</span>
      )}
    </>
  );

  return (
    <EntityCombobox
      value={value || ""}
      onChange={onChange}
      items={lista}
      getLabel={label}
      getSecondary={secondary}
      getSearchText={searchText}
      getBadge={badge}
      icon={MapPin}
      placeholder={placeholder}
      searchPlaceholder="Centro, enseña, nº tienda, dirección, ciudad, CP…"
      emptyText={emptyText}
      allowNone={allowNone}
      noneLabel={noneLabel}
      disabled={disabled}
      testId={testId}
      className={className}
      recentsKey="espacios"
    />
  );
}
